export const convertListToObject = list =>
  list.reduce(
    (listObject, currentListItem) => ({ ...listObject, ...currentListItem }),
    {},
  );
